import './card-service.scss';

export default () => {
};
